import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SGKC027AService, Sgkc027aRequest, Sgkc027aResponse } from 'sg-api';

/**
 * スライド調整単価承認権限取得API使用サービス
 * @export
 * @class UsedSgkc027aService
 */
@Injectable({
    providedIn: 'root'
})

export class UsedSgkc027aService {

    /**スライド調整単価承認権限取得結果の結果のSubject */
    private _tankatableAuthorityInformationResult$: Subject<Sgkc027aResponse> = new Subject<Sgkc027aResponse>();

    /**
   * コンストラクタ
   * @param {SGKC027AService} sGKC027AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgkc027aService
   */
    constructor(
        private sGKC027AService: SGKC027AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
     * スライド調整単価承認権限取得結果のobservable提供
     * @readonly
     * @memberof UsedSgkc027aService
     */
    get slideTankatableAuthorityChanges() {
        return this._tankatableAuthorityInformationResult$.asObservable();
    }

    /**
       * スライド調整単価承認権限取得API呼び出し
       * @param {Sgkc027aRequest} value スライド調整単価承認権限取得リクエストパラメータ
       * @return {Observable<Sgkc027aResponse>} スライド調整単価承認権限取得結果
       * @memberof UsedSgkc027aService
       */
    getSlideTankatableAuthorityInf(value: Sgkc027aRequest): Observable<Sgkc027aResponse> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC027AService.kC10RSGKC027APost(<Sgkc027aRequest>this.apiCommonService.setRequestCommon(value), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._tankatableAuthorityInformationResult$.next(response.body);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC027A');
                    return throwError(err.message);
                })
            );
    }
}
